/**
 * TOOLS - różne narzędzia
 */

import { TOOLS_DATA, SHOW_SPINNER, HIDE_SPINNER } from "../types";
import api from "../../api";
import sessionErrHandler from "./sessionErrHandler";
import { getCourseSections } from "./index";

// --------  Pobieranie listy obrazków z api do HOT POINTS  --------

let idx, sections, imgList;
export const getHotPointsImages = () => async (dispatch, getState) => {
  imgList = [];
  sections = [];
  idx = 0;
  sections = getState().courseSections;
  if (!sections.length) {
    const courseId = getState().userState.currentCourseId;
    dispatch({
      type: TOOLS_DATA,
      data: "Pusta lista - Pobieram listę, kliknij jeszcze raz",
    });
    dispatch(getCourseSections(courseId));
    return;
  }
  dispatch({ type: SHOW_SPINNER, payload: "Tworzenie listy obrazów do HP..." });
  getSection(dispatch);
};

const getSection = async (dispatch) => {
  if (sections[idx].game) {
    if (++idx === sections.length) {
      finalizeHP(dispatch);
      return;
    }
    getSection(dispatch);
    return;
  }
  console.log("Pobieram " + sections[idx].title);
  // Pobieranie danych sekcji
  let options = {
    method: "get",
    url: `/segment/${sections[idx].id}`,
    withCredentials: true,
  };
  let response = {};
  try {
    response = await api(options);
  } catch (e) {
    sessionErrHandler(e, "Błąd Pobierania Sekcji", dispatch);
    dispatch({ type: HIDE_SPINNER });
  }
  if (response.status !== 200) {
    dispatch({ type: HIDE_SPINNER });
    return console.log("Coś poszło nie tak");
  }

  // są dane sekcji - pobieranie danych ćwiczenia
  const data = response.data;
  const hp = data.find((e) => e.type === "HOT_POINTS");
  if (!hp) {
    if (++idx === sections.length) {
      finalizeHP(dispatch);
      return;
    }
    getSection(dispatch);
    return;
  }
  options = {
    method: "get",
    url: `/course/activation/HOT_POINTS/${hp.id}`,
    withCredentials: true,
  };
  response = {};
  try {
    response = await api(options);
  } catch (e) {
    sessionErrHandler(e, "Błąd Pobierania Sekcji", dispatch);
    dispatch({ type: HIDE_SPINNER });
  }
  if (response.status !== 200) {
    dispatch({ type: HIDE_SPINNER });
    return console.log("Coś poszło nie tak 2");
  }
  imgList = [...imgList, ...parseHPImages(response.data)];
  if (++idx === sections.length) {
    finalizeHP(dispatch);
    return;
  }
  getSection(dispatch);
};

function parseHPImages(data) {
  const images = [];
  images.push(decodeURIComponent(data.imageUrl));
  data.words.forEach((data) => {
    images.push(decodeURIComponent(data.img1.url));
    if (data.img2.show) images.push(decodeURIComponent(data.img2.url));
  });
  return images;
}

function finalizeHP(dispatch) {
  dispatch({ type: HIDE_SPINNER });
  dispatch({ type: TOOLS_DATA, data: imgList });
}

// ----------------------------------------------------------
// --------  Pobieranie listy obrazków z api do HISTORY  --------

export const getHistoryImages = async () => {};
